export const getInitialPaymentInPercents = (price: number, initialPayment: number): string => {
  let percents = Math.round((initialPayment / price) * 100);

  if (isNaN(percents) || percents < 0) {
    percents = 0;
  }

  if (percents > 100) {
    percents = 100;
  }

  return `${percents}%`;
};
